import React, { createContext, useMemo } from 'react'
import { useJsApiLoader } from '@react-google-maps/api'
import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url'

interface ContextType {
  isLoaded: boolean
  loadError: Error | undefined
}
const GoogleMapsLoadedContext = createContext<ContextType>({
  isLoaded: false,
  loadError: undefined,
})

const libraries: Libraries = ['drawing', 'places']

const GoogleMapsLoadedProvider: React.FC<{ children?: React.ReactNode }> = (props) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyBAuPgEFy4GVPydmm3dCg_WZ0mFgFwR_Sk',
    libraries,
  })

  const value = useMemo(() => ({ isLoaded, loadError }), [isLoaded, loadError])

  return (
    <GoogleMapsLoadedContext.Provider value={value}>
      {props.children}
    </GoogleMapsLoadedContext.Provider>
  )
}

export { GoogleMapsLoadedProvider, GoogleMapsLoadedContext }
